import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPharmaSettlementSlice = createAsyncThunk(
  "PharmaSettlement/createPharmaSettlement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSettlement/createPharmaSettlement",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllPharmaSettlementSlice = createAsyncThunk(
  "PharmaSettlement/getAllPharmaSettlement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSettlement/getAllPharmaSettlement",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPharmaSettlementByIdSlice = createAsyncThunk(
  "PharmaSettlement/getPharmaSettlementById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSettlement/getPharmaSettlementById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const updatePharmaSettlementSlice = createAsyncThunk(
  "PharmaSettlement/updatePharmaSettlement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/pharmaSettlement/updatePharmaSettlement",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
const initialState = {
  pharmaSettlement: [],
  pharmaSettlementInfo: [],
  isLoading: false,
  createPharmaSettlementSuccessMessage: null,
  createPharmaSettlementErrorMessage: null,
  updatePharmaSettlementSuccessMessage: null,
  updatePharmaSettlementErrorMessage: null,
  searchPharmaSettlementErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const pharmaSettlementSlice = createSlice({
  name: "pharmaSettlement",
  initialState,
  reducers: {
    resetAddPharmaSettlementMessage: (state) => {
      state.createPharmaSettlementSuccessMessage = null;
      state.createPharmaSettlementErrorMessage = null;
    },
    resetUpdatePharmaSettlementMessage: (state) => {
      state.updatePharmaSettlementSuccessMessage = null;
      state.updatePharmaSettlementErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPharmaSettlementSlice.pending, (state) => {
        state.isLoading = true;
        state.createPharmaSettlementSuccessMessage = null;
        state.createPharmaSettlementErrorMessage = null;
      })
      .addCase(createPharmaSettlementSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createPharmaSettlementErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.createPharmaSettlementSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(createPharmaSettlementSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllPharmaSettlementSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPharmaSettlementSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.pharmaSettlement = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchPharmaSettlementErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.pharmaSettlement = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchPharmaSettlementErrorMessage = null;
      })
      .addCase(getAllPharmaSettlementSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSettlementErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getPharmaSettlementByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPharmaSettlementByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pharmaSettlementInfo = action?.payload?.result?.list;
      })
      .addCase(getPharmaSettlementByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSettlementErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(updatePharmaSettlementSlice.pending, (state) => {
        state.isLoading = true;
        state.updatePharmaSettlementSuccessMessage = null;
        state.updatePharmaSettlementErrorMessage = null;
      })
      .addCase(updatePharmaSettlementSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updatePharmaSettlementErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.updatePharmaSettlementSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(updatePharmaSettlementSlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});
export const {
  resetAddPharmaSettlementMessage,
  resetUpdatePharmaSettlementMessage,
} = pharmaSettlementSlice.actions;

export default pharmaSettlementSlice.reducer;
